import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useAssembleProductStyles } from './styles';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { schema } from './validation/schema';
import { numberValidation } from '../../../../../../../helpers/OnlyNumbers';
import { bodyIssueTicketGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';

const AssembleProduct = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile } = props;
  const classes = useAssembleProductStyles({ mobile });

  const [phone, setPhone] = useState('');
  const [phoneValidation, setPhoneValidation] = useState('');
  const [address, setAddress] = useState('');
  const [addressValidation, setAddressValidation] = useState('');
  const [comment, setComment] = useState('');
  const [checked, setChecked] = useState(false);
  const [helper, setHelper] = useState('0/250');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();

  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);

  const handlePhone = (e) => {
    setPhone(e.target.value);
  };
  const handleAddress = (e) => {
    setAddress(e.target.value);
  };

  const handleComment = (e) => {
    const { value } = e.target;

    if (value.length <= 250) {
      setComment(value);
      setHelper(`${value.length}/250`);
    }
  };

  const blurPhone = (e) => {
    const { value } = e.target;
    const isNum = numberValidation(value);

    if (isNum) {
      if (value.length > 9 || value.length < 9) {
        setSuccess(false);
        setError(true);
        setPhoneValidation('error');
      } else {
        setSuccess(true);
        setError(false);
        setPhoneValidation('valid');
      }
    } else {
      setError(true);
      setSuccess(false);
      setPhoneValidation('error');
    }
  };

  const blurAddress = () => {
    if ('error' in schema.validate({ address })) {
      setAddressValidation('error');
      setErrorMessage(schema.validate({ address }).error.message);
    } else {
      setAddressValidation('valid');
      setErrorMessage('');
    }
  };

  const handleButton = () => {
    const body = {
      oc: product.orderId,
      sku: product.sku,
      direccion_armado: address,
      ...bodyIssueTicketGenerator({
        profile,
        type,
        motiveId,
        phone,
        comment,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <Typography className={classes.subTitle}>Ingresa los datos</Typography>

      <AppInput
        value={phone}
        onChange={handlePhone}
        onClick={() => {}}
        required
        label="Teléfono"
        error={error}
        errorMessage={'Teléfono consta de 9 dígitos'}
        onBlur={blurPhone}
        success={success}
      />

      <AppInput
        value={address}
        onChange={handleAddress}
        onClick={() => {}}
        required
        label="Dirección de despacho"
        onBlur={blurAddress}
        success={addressValidation === 'valid'}
        error={addressValidation === 'error'}
        errorMessage={errorMessage}
      />

      <AppInput
        value={comment}
        onChange={handleComment}
        onClick={() => {}}
        multiline
        label="Cuéntanos qué necesitas"
        helperText={helper}
      />

      <AuthorizeCheckbox
        idComplement="AssembleProduct"
        onCheck={() => setChecked(!checked)}
        disabled={phoneValidation !== 'valid' || addressValidation !== 'valid'}
      />

      <LoadingButton
        className={classes.sendButton}
        variant="contained"
        color="primary"
        text="Enviar solicitud"
        disabled={
          !checked ||
          phoneValidation !== 'valid' ||
          addressValidation !== 'valid'
        }
        loading={ticketNoProductStatus === 'loading'}
        onClick={handleButton}
        data-cy="AssembleProduct"
      />
    </Box>
  );
};

AssembleProduct.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
};

export default AssembleProduct;
